import axiosInstance from './axiosConfig';
import { AxiosResponse } from 'axios';
import { generateBFFUrl } from '@/configs/apiEndPoints';
import { ERROR } from '@/configs/constants';
import { GenericError } from '@/errors/GenericServerError';
import dlv from 'dlv';
import { PINCODE_DATA } from '@/configs/ecom/apis';

export const fetchPincodeData = async (pincode: string): Promise<any> => {
  try {
    const response = await axiosInstance.get(generateBFFUrl(`${PINCODE_DATA}/${pincode}`), {
      params: {},
    });
    return dlv(response, 'data.data', []);
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError(ERROR.GENERIC_MESSAGE, status, statusText, data);
  }
};
